// extracted by mini-css-extract-plugin
export default {"container":"MH+32","notFirstItem":"foikQ","pimple":"HZJKk","pimpleFullButton":"JzgLw","pimpleHollowButton":"ptz2h","updatedIndicationText":"VEOH2"};